import { UICouponType, CouponButtonType,  CouponTagColor, ThemeColor, NumberFontSize, CouponTipsType, CouponInfo } from '@tencent/wphk-act-base-types';

export { CouponButtonType,  CouponTagColor, ThemeColor, NumberFontSize, CouponTipsType, CouponInfo };

/** 优惠券类型 */
export enum CouponType {
  /** 默认(带prize logo券) */
  default = UICouponType.default,
  /** 现金券 */
  cash = UICouponType.cash,
  /** 折扣券 */
  discount = UICouponType.discount,
  /** 连锁券 */
  // chain = 'chain',
};
